import styled from 'styled-components';
import { Button } from 'antd';

export const ConfigPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    min-height: 85vh;
    height: 10vh;
`;

export const ContentContainer = styled.div`
    width: 100%;
    height: 100%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    gap: 32px;

    .ant-collapse {
        background-color: transparent;
        border: none;
        border-radius: 16px;
    }

    .ant-collapse-header {
        color: ${({ theme }) => theme?.colors?.text?.headings} !important;
    }

    .ant-collapse-content {
        color: ${({ theme }) => theme?.colors?.text?.paragraphs};
        background-color: transparent;
    }
`;

export const StyleButtonTheme = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    
    button.button-theme {
        color: ${({ theme }) => theme?.colors?.text?.headings} !important;
        border: none !important;
        box-shadow: none !important;

        &:active {
            border: none !important;
        }
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: left;
    height: 100%;
`;

export const StyledButton = styled(Button)`
    border-radius: var(--Sizes-borderRadiusInput, 32px);
    display: flex;
    padding: var(--Sizes---sise-s, 8px) var(--Sizes---zero, 0px);
    align-items: center;
    gap: var(--Sizes---sise-s, 8px);
    align-self: stretch;
    justify-content: left;
    background: none !important;
    height: auto;
    color: ${({ theme }) => theme?.colors?.text?.headings};
    border: none !important;
    box-shadow: none !important;

    img {
        filter: ${({ theme }) => theme?.name !== 'dark' ? 'invert(1) brightness(0)' : 'none'};
    }

    &:hover {
        color: ${({ theme }) => theme?.colors?.theme?.brandColor3} !important;
    }

    &.danger {
        color: ${({ theme }) => theme?.colors?.common?.red};
    }
`;

export const AccountRow = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 0;
    gap: 16px;

    &:last-child {
        border-bottom: none;
    }
`;

export const AccountImage = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    filter: ${({ theme }) => theme?.name !== 'dark' ? 'invert(1) brightness(0)' : 'none'};
`;

export const AccountInfo = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const AccountName = styled.span`
    font-family: "Red Hat Display", Arial;
    font-weight: 700;
    color: ${({ theme }) => theme?.colors?.text?.headings};
`;

export const Title = styled.h1`
    color: ${({ theme }) => theme?.colors?.text?.headings};
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;

